export default "__VITE_ASSET__C56MCXl9__"